<template>
  <div class="social-share">
    <p class="social-share__title">
      {{ title }}
    </p>

    <div class="social-share__buttons">
      <a
        v-for="network in networks"
        :key="network.name"
        :href="network.url"
        :aria-label="`Partager sur ${network.name}`"
        class="social-share__button"
        target="_blank"
        rel="noopener noreferrer">
        <svg
          class="social-share__icon"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true">
          <path :d="network.path" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Partagez sur les réseaux sociaux !',
  },
  url: {
    type: String,
    required: true,
  },
  articleTitle: {
    type: String,
    default: '',
  },
})

// Paths SVG des icônes (style solide, simple)
const ICONS = {
  facebook:
    'M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z',
  linkedin:
    'M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z',
  twitter:
    'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z',
}

const networks = computed(() => {
  const encodedUrl = encodeURIComponent(props.url)
  const encodedTitle = encodeURIComponent(props.articleTitle)

  return [
    {
      name: 'Facebook',
      path: ICONS.facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: 'LinkedIn',
      path: ICONS.linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      name: 'Twitter',
      path: ICONS.twitter,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    },
  ]
})
</script>

<style scoped>
.social-share {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 24px 32px;
  border-radius: 12px;
}

.social-share__title {
  margin: 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-align: center;
  letter-spacing: 0.2px;
}

.social-share__buttons {
  display: flex;
  gap: 14px;
}

.social-share__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1.5px solid #2b8cff;
  border-radius: 50%;
  color: #2b8cff;
  text-decoration: none;
  background-color: transparent;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.social-share__button:hover {
  background-color: #2b8cff;
  color: #ffffff;
  transform: translateY(-2px);
}

.social-share__button:focus-visible {
  outline: 2px solid #2b8cff;
  outline-offset: 3px;
}

.social-share__icon {
  width: 18px;
  height: 18px;
}
</style>
